var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    { attrs: { value: _vm.value, persistent: "", "max-width": "500px" } },
    [
      _c(
        "v-card",
        { attrs: { color: "fill" } },
        [
          _c(
            "v-toolbar",
            { staticClass: "main", attrs: { flat: "", dark: "" } },
            [_c("v-toolbar-title", [_vm._v(" TPR Alignment Export ")])],
            1
          ),
          _c(
            "v-card-text",
            { staticClass: "my-0 py-0" },
            [
              _c(
                "v-container",
                { attrs: { fluid: "" } },
                [
                  _c(
                    "v-row",
                    [
                      _c("v-col", [
                        _vm._v(
                          " Select a TPR/EDLC start date and at least one ad group to generate an alignment export. "
                        )
                      ])
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        [
                          _c(
                            "v-menu",
                            {
                              attrs: {
                                transition: "scale-transition",
                                "offset-y": "",
                                "max-width": "290px",
                                "min-width": "290px"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _c(
                                        "v-text-field",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              attrs: {
                                                label: "TPR/EDLC Start Date",
                                                "prepend-inner-icon":
                                                  "mdi-calendar",
                                                dense: "",
                                                type: "date",
                                                "background-color": "#fff",
                                                outlined: "",
                                                "hide-details": "",
                                                clearable: ""
                                              },
                                              model: {
                                                value: _vm.tpr_start_date,
                                                callback: function($$v) {
                                                  _vm.tpr_start_date = $$v
                                                },
                                                expression: "tpr_start_date"
                                              }
                                            },
                                            "v-text-field",
                                            attrs,
                                            false
                                          ),
                                          on
                                        )
                                      )
                                    ]
                                  }
                                }
                              ]),
                              model: {
                                value: _vm.start_dt_picker,
                                callback: function($$v) {
                                  _vm.start_dt_picker = $$v
                                },
                                expression: "start_dt_picker"
                              }
                            },
                            [
                              _c("v-date-picker", {
                                attrs: {
                                  "allowed-dates": _vm.allowedDates,
                                  "show-current": "",
                                  scrollable: "",
                                  "no-title": ""
                                },
                                model: {
                                  value: _vm.tpr_start_date,
                                  callback: function($$v) {
                                    _vm.tpr_start_date = $$v
                                  },
                                  expression: "tpr_start_date"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              label: "Ad Groups",
                              items: _vm.activeAdGroups,
                              "item-text": "name",
                              "item-value": "id",
                              "menu-props": { offsetY: true },
                              "background-color": "input",
                              "hide-details": "auto",
                              multiple: "",
                              chips: "",
                              "small-chips": "",
                              outlined: "",
                              clearable: "",
                              dense: ""
                            },
                            model: {
                              value: _vm.ad_group_ids,
                              callback: function($$v) {
                                _vm.ad_group_ids = $$v
                              },
                              expression: "ad_group_ids"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-col",
                { attrs: { cols: "auto" } },
                [
                  _c(
                    "v-btn",
                    { attrs: { text: "" }, on: { click: _vm.close } },
                    [_vm._v(" Cancel ")]
                  )
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "auto" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary",
                        disabled: _vm.disabled,
                        loading: _vm.generating
                      },
                      on: { click: _vm.generateExport }
                    },
                    [_vm._v(" Generate ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }